import { TourConfig, startTour, CONTINUE_PLATFORM_TOUR_BUTTON } from './TourSystem';
import PageWelcomeModal from './PageWelcomeModal';
import 'driver.js/dist/driver.css';

const hrPayrollTourConfig: TourConfig = {
    tourId: 'hr-payroll',
    steps: [
        {
            element: '#hr-stats',
            popover: {
                title: '📊 Workforce Overview',
                description: 'Real-time metrics on total employees, monthly payroll cost, and compliance status.',
                side: "bottom",
            }
        },
        {
            element: '#hr-payroll-section',
            popover: {
                title: '💰 Smart Payroll',
                description: 'Run automated payroll across 50+ countries. Track next pay runs and approve pending requests instantly.',
                side: "top",
            }
        },
        {
            element: '#hr-compliance-section',
            popover: {
                title: '⚖️ Compliance Center',
                description: 'Stay legal with automated tax generation and benefits management. We flag expiring contracts automatically.',
                side: "top",
            }
        },
        {
            element: '#hr-directory-section',
            popover: {
                title: '👥 Team Directory',
                description: 'Access full profiles for all your team members, contractors, and freelancers.',
                side: "top",
            }
        },
        {
            popover: {
                title: '🚀 Admin Simplified',
                description: `Manage your global team with ease and confidence.${CONTINUE_PLATFORM_TOUR_BUTTON}`,
            }
        }
    ],
};

export const startHRPayrollTour = () => {
    startTour(hrPayrollTourConfig);
};

const HRPayrollTour = () => {
    return (
        <PageWelcomeModal
            title="Welcome to HR & Payroll"
            description="Streamlined payroll management and global compliance."
            onStartTour={startHRPayrollTour}
            tourId="hr-payroll"
        />
    );
};

export default HRPayrollTour;
